<script setup lang="ts">
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import IconUser from '~/assets/icons/layout/icon-user.svg'

const { $bmAuth } = useNuxtApp()
const router = useRouter()

const logout = async () => {
  $bmAuth.logout()
  await router.replace('/login')
}

const userNavigation = [
  { name: 'My Account', href: '/account' },
  { name: 'Subscriptions', href: '/account/subscriptions' },
  { name: 'Change Password', href: '/account' },
  { name: 'Sign out', action: logout },
]
</script>

<template>
  <Menu as="div" class="relative">
    <MenuButton class="flex cursor-pointer items-center p-1.5">
      <span class="sr-only">Open user menu</span>
      <IconUser
        class="size-6 text-p-500 transition-colors duration-200 hover:text-white"
        aria-hidden="true"
      />
    </MenuButton>
    <transition
      enter-active-class="transition ease-out duration-100"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <MenuItems
        class="focus:outline-hidden absolute right-0 z-user-menu mt-3.5 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-grey-900/5"
      >
        <MenuItem
          v-for="item in userNavigation"
          :key="item.name"
          v-slot="{ active }"
        >
          <button
            v-if="item.action"
            :class="[
              active ? 'outline-hidden bg-grey-100' : '',
              'block w-full px-3 py-1.5 text-left text-sm text-grey-900',
            ]"
            @click="item.action"
          >
            {{ item.name }}
          </button>
          <NuxtLink
            v-else
            :to="item.href"
            :class="[
              active ? 'outline-hidden bg-grey-100' : '',
              'block px-3 py-1.5 text-sm text-grey-900',
            ]"
          >
            {{ item.name }}
          </NuxtLink>
        </MenuItem>
      </MenuItems>
    </transition>
  </Menu>
</template>
